import Prices from './prices';

class Variants {

    constructor() {

        this.variant;

        this.tshirtPrice = 0;
        this.printPrice = 0;
        this.summaryPrice = 0;

        this.tshirtElement = '#personalizator__product-tshirt';
        this.printElement = '#personalizator__print-price';
        this.summaryElement = '#personalizator__summary-price';

        this.qty = '#personalizator__qty';

        this.container = '.variant-sizes';
        this.element = '.variant-sizes .variant-item';
        this.selectedClass = 'selected';

        this.pickVariant();
        this.bindChange();
        this.bindQty();

    }



    pickVariant() {
        $(document).ready(() => {
            this.variant = $(`${this.element}[${this.selectedClass}]`);
        });

        return true;
    }

    bindChange() {

        $(document).ready(() => {

            $(this.container).change((event) => {

                Prices.updatePrices();

                return false;
            });

        });

        return true;

    }

    bindQty() {

        $(document).ready(() => {

            $(this.qty).on('blur change keyup', () => {

                Prices.updatePrices();

            });

        });

    }

}


export const variants = new Variants();
